import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
  PLAYSTORE_APP_LINK, getEnv,
} from '../../api/env';
import i18n from '../common/i18n';

const HomeDownloadAppSection = () => {
  const DOWNLOAD_APP_LINK = `${getEnv(PLAYSTORE_APP_LINK)}?id=ar.com.credicuotas.autogestion.twa`;
  const isMobile = useMediaQuery('(max-width: 1024px)');

  const handleClick = () => {
    window.open(DOWNLOAD_APP_LINK, '_blank');
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{
        margin: 'auto',
        marginTop: '16px',
        marginBottom: '16px',
      }}
    >
      {isMobile ? (
        <>
          <Box
            className="boxDownloadAppMobile"
            sx={{
              border: 'none !important',
              boxShadow: 'unset !important',
              borderRadius: '12px !important',
              padding: '0px',
              width: '90%',
            }}
          />
          <Box
            sx={{
              width: '90%',
            }}
          >
            <Button
              variant="contained"
              className="ButtonMagenta"
              onClick={() => handleClick()}
              style={{
                display: 'flex',
                alignItems: 'center',
                fontFamily: 'Open sans !important',
                fontWeight: 700,
                marginTop: '16px',
              }}
              fullWidth
              endIcon={(<GetAppIcon />)}
            >
              {i18n.homeDownloadApp}
            </Button>
          </Box>
        </>
      ) : (
        <Box
          className="boxDownloadApp"
          sx={{
            border: 'none !important',
            boxShadow: 'unset !important',
            borderRadius: '12px !important',
            padding: '32px',
            width: '85%',
          }}
        >
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Typography variant="h4" className="alignLeft" fontWeight={700} pb={1}>{i18n.homeDownloadApp}</Typography>
              <Typography variant="h6" className="alignLeft">{i18n.homeDownloadAppText}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Button
                variant="contained"
                className="ButtonMagenta"
                onClick={() => handleClick()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontFamily: 'Open sans !important',
                  fontWeight: 700,
                }}
                fullWidth
                endIcon={(<GetAppIcon />)}
              >
                {i18n.homeDownloadApp}
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default HomeDownloadAppSection;
